import { createElementBlock as e, openBlock as o, createElementVNode as t } from "vue";
const n = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 18 18"
};
function r(a, l) {
  return o(), e("svg", n, [...l[0] || (l[0] = [
    t("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M8.5.794c.248 0 .474.141.583.364l2.121 4.339 4.741.695a.649.649 0 0 1 .361 1.104l-3.434 3.38.81 4.772a.649.649 0 0 1-.943.682L8.5 13.88l-4.24 2.25a.649.649 0 0 1-.943-.681l.811-4.774L.694 7.296a.649.649 0 0 1 .36-1.104l4.742-.695 2.121-4.34A.65.65 0 0 1 8.5.795Zm0 2.125L6.811 6.374a.65.65 0 0 1-.489.357l-3.789.555L5.28 9.988c.151.149.22.362.185.571l-.647 3.807 3.379-1.793c.19-.1.418-.1.608 0l3.38 1.793-.648-3.807a.65.65 0 0 1 .185-.57l2.746-2.703-3.79-.555a.65.65 0 0 1-.488-.357z",
      "clip-rule": "evenodd"
    }, null, -1)
  ])]);
}
const d = { render: r };
export {
  d as default,
  r as render
};
